(function() {
    angular
        .module("loginModule")
        .controller("ForgotController", ForgotController)

    ForgotController.$inject = [
        "$rootScope",
        "$scope",
        "authenticationService",
        "usersService",
        "userMessagingService"
    ]

    function ForgotController(
        $rootScope,
        $scope,
        authenticationService,
        usersService,
        userMessagingService
    ){
        "use strict"

        authenticationService.logoutSoft()

        /**
            $rootScope variables
         **/
        $rootScope.title = "Forgot Password | WANCO"

        /**
            $scope variables
         **/
        $scope.forgotFormData = {}

        /**
            Forgot password request
         **/
        $scope.forgot = function() {
            $scope.submitted = true
            $scope.formSuccess = false
            if ($scope.forgotForm.$valid) {
                usersService.requestPasswordReset(
                    $scope.forgotFormData.email,
                    function() {
                        //Success
                        userMessagingService.success("Password Reset Request Sent: Please check your email for further instructions.")
                    },
                    function(error) {
                        //Failure
                        userMessagingService.error(error)
                    }
                )
            }
        }
    }
})()
